const initialState = {
  markers: [],
  show: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'GEAR_DROP_MARKERS_SET':
      return { ...state, markers: payload }
    case 'GEAR_DROP_SHOW':
      return { ...state, show: true }
    case 'GEAR_DROP_HIDE':
      return { ...state, markers: [], show: false }
    case 'logout':
      return null
    default:
      return state
  }
}
